import { useRef } from 'react';
import { useDropdown } from '@/hooks/useDropdown';
import MenuItem from './MenuItem';
import UserNameDisplay from './UserNameDisplay';

type ProfileMenuProps = {
  isOpen: boolean;
  onClose: () => void;
  onPoolsDashboardClick: () => void;
  onLogout: () => void;
  anchorRef: React.RefObject<HTMLElement | null>;
};

export default function ProfileMenu({ isOpen, onClose, onPoolsDashboardClick, onLogout, anchorRef }: ProfileMenuProps) {
  const menuRef = useRef<HTMLDivElement>(null);
  useDropdown({ isOpen, onClose, anchorRef, dropdownRefs: [menuRef] });

  if (!isOpen) return null;

  return (
    <div
      ref={menuRef}
      className="animate-slideDown w-[220px] max-w-[calc(100vw-2rem)] pt-1 px-1 pb-6 absolute top-12 right-0 bg-[#F4F4F4] overflow-hidden rounded-3xl border border-[#E5E7EB] inline-flex flex-col justify-end items-stretch gap-3.5 z-50"
      role="menu"
    >
      <UserNameDisplay />
      <div className="w-full px-5 flex flex-col gap-3.5 mt-2">
        <MenuItem variant="default" onClick={onPoolsDashboardClick}>
          Pools & Dashboard
        </MenuItem>
        <MenuItem variant="muted">Profile</MenuItem>
        <MenuItem variant="danger" onClick={onLogout}>
          Log out
        </MenuItem>
      </div>
    </div>
  );
}
